import AppRouter from './routes/AppRouter';
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import { ConfigProvider, theme as antdTheme } from "antd";
import './App.css';
import './Theme.css';

function ThemedRouter() {
  const { theme } = useTheme();
  return <ConfigProvider theme={{ algorithm: theme === "dark" ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm }}><AppRouter /></ConfigProvider>;
}

function App() {
  return (
    <ThemeProvider><AuthProvider><ThemedRouter /></AuthProvider></ThemeProvider>
  );
}

export default App;
